import CSS from './CSS.component';

export default CSS;
